import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

// Vuex Store
import store from '../store'

// Paths
import PATHS from '../router/routesMap'

// Utils
import popExitingConfirmation from '../utils/popExitingConfirmation'

// Autenticacao
import Login from '../components/views/login/Login'
import CadastrarSenha from '../components/views/login/CadastrarSenha'
import LoginEmulado from '../components/views/login/LoginEmulado'
import TrocaAplicacao from '../components/views/login/TrocaAplicacao'
// Home
import Home from '../components/views/home/Home'
import IndexPage from '../components/views/index/Index'
// Movimentos
import BankStatement from '../components/views/reports/bankStatement/BankStatement'
import BankBalance from '../components/views/reports/bankBalance/BankBalance'
import DigitalWalletBalance from '../components/views/reports/digitalWalletBalance/DigitalWalletBalance'
import DuplicateMovementsAnalysis from '../components/views/reports/duplicateMovementsAnalysis/DuplicateMovementsAnalysis'
import FinancialMovement from '../components/views/reports/financialMovement/FinancialMovement'
// Conciliacao
import ConciliationReport from '../components/views/reports/conciliationReport/ConciliationReport'
import ConciliationSummary from '../components/views/reports/conciliationSummary/ConciliationSummary'
import ManualConciliation from '../components/views/reports/manualConciliation/ManualConciliation'
import OccurrenceReport from '../components/views/reports/occurrenceReport/OccurrenceReport'
// Integracoes
import ProcessedFiles from '../components/views/integration/processedFiles/ProcessedFiles'
import FileUpload from '../components/views/integration/fileUpload/FileUpload'
import RemittanceIntegration from '../components/views/integration/remittanceIntegration/RemittanceIntegration'
// Cadastros
import BankingAccountsList from '../components/views/registration/bankAccounts/List'
import NewBankingAccount from '../components/views/registration/bankAccounts/New'
import EstablishmentsList from '../components/views/registration/establishments/List.vue'
import NewEstablishment from '../components/views/registration/establishments/New.vue'
import MoveEstablishment from '../components/views/registration/establishments/Move.vue'
import CategoriesList from '../components/views/registration/categories/List'
import ListConciliationPlan from '../components/views/registration/conciliationPlan/List'
import NewConciliationPlan from '../components/views/registration/conciliationPlan/New'
import OccurrenceReasonList from '../components/views/registration/occurrenceReason/List'
import NewOccurrenceReason from '../components/views/registration/occurrenceReason/New'
import AttributesSetList from '../components/views/registration/attributesSet/List'
import NewAttributesSet from '../components/views/registration/attributesSet/New'
// Administracao
import AccessProfileList from '../components/views/administration/accessProfile/List'
import NewAccessProfile from '../components/views/administration/accessProfile/New'
import OperatorsList from '../components/views/administration/operator/List'
import NewOperator from '../components/views/administration/operator/New'
import AssignmentList from '../components/views/administration/assignment/List'
import AuditLog from '../components/views/administration/auditLog/AuditLog'
// Unauthorized | NotFound
import Unauthorized from '../components/views/unauthorized/Unauthorized'
import NotFound from '../components/views/notFound/NotFound'

import OfdaRegDeeplink from '../components/views/registration/bankAccounts/OfdaDeepLink'

const router = new Router({
  mode: 'history',
  routes: [{
    path: PATHS.BANKING,
    component: Login
  }, {
    path: PATHS.PASSWORD_RECOVERY,
    component: CadastrarSenha
  }, {
    path: PATHS.NEW_PASSWORD,
    component: CadastrarSenha
  }, {
    path: PATHS.LOGIN_EMULADO,
    component: LoginEmulado
  }, {
    path: PATHS.OFDA_REG_DEEPLINK,
    component: OfdaRegDeeplink
  }, {
    path: PATHS.TROCA_APLICACAO,
    component: TrocaAplicacao
  }, {
    path: PATHS.HOME,
    component: Home,
    children: [{
      path: PATHS.HOME,
      component: IndexPage
    }, {
      path: PATHS.BANK_STATEMENT,
      component: BankStatement,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.BANK_BALANCE,
      component: BankBalance,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.DIGITAL_WALLET_BALANCE,
      component: DigitalWalletBalance,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.DUPLICATE_MOVEMENTS_ANALYSIS,
      component: DuplicateMovementsAnalysis,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.FINANCIAL_MOVEMENT,
      component: FinancialMovement,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.CONCILIATION_REPORT,
      component: ConciliationReport,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.CONCILIATION_SUMMARY,
      component: ConciliationSummary,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.CONCILIATION_SUMMARY_CALENDAR,
      component: ConciliationSummary,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.MANUAL_CONCILIATION,
      component: ManualConciliation,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.OCCURRENCE_REPORT,
      component: OccurrenceReport,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.PROCESSED_FILES,
      component: ProcessedFiles,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.FILE_UPLOAD,
      component: FileUpload,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.REMITTANCE_INTEGRATION,
      component: RemittanceIntegration,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.LIST_BANK_ACCOUNTS,
      component: BankingAccountsList,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.NEW_BANK_ACCOUNT,
      component: NewBankingAccount,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.LIST_ESTABLISHMENTS,
      component: EstablishmentsList,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.NEW_ESTABLISHMENT,
      component: NewEstablishment,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.MOVE_ESTABLISHMENT,
      component: MoveEstablishment,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.CATEGORIES,
      component: CategoriesList,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.LIST_CONCILIATION_PLANS,
      component: ListConciliationPlan,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.NEW_CONCILIATION_PLAN,
      component: NewConciliationPlan,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.LIST_OCCURRENCE_REASONS,
      component: OccurrenceReasonList,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.NEW_OCCURRENCE_REASON,
      component: NewOccurrenceReason,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.LIST_ATTRIBUTES_SET,
      component: AttributesSetList,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.NEW_ATTRIBUTES_SET,
      component: NewAttributesSet,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.LIST_ACCESS_PROFILE,
      component: AccessProfileList,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.NEW_ACCESS_PROFILE,
      component: NewAccessProfile,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.LIST_OPERATORS,
      component: OperatorsList,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.NEW_OPERATOR,
      component: NewOperator,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.LIST_ASSIGNMENT,
      component: AssignmentList,
      meta: {
        requiresAuth: true
      }
    }, {
      path: PATHS.AUDIT_LOG,
      component: AuditLog,
      meta: {
        requiresAuth: true
      }
    }]
  }, {
    path: PATHS.UNAUTHORIZED,
    component: Unauthorized
  }, {
    path: '*',
    component: NotFound
  }]
})

router.beforeResolve((to, from, next) => {
  let response = false
  if (!store.getters.hasUnsavedChanges || popExitingConfirmation()) {
    response = true
    next()
  }
  store.dispatch('setConfirmResponse', response)
})

router.beforeEach((to, from, next) => {
  if (localStorage.getItem('CONNECTION_ERROR')) {
    localStorage.removeItem('CONNECTION_ERROR')
    store.dispatch('cleanSession')
    router.push(PATHS.LOGIN)
  } else if (store.getters.isLoggedIn && (to.path === PATHS.BANKING || to.path === (PATHS.BANKING + '/'))) {
    // Usuário logado tentando acessar a página de login
    store.dispatch('clearSelectedMenuItem')
    router.push(PATHS.HOME)
  } else if (!store.getters.isLoggedIn && (to.path === PATHS.HOME || to.path === (PATHS.HOME + '/'))) {
    // Usuário não logado tentando acessar a home
    router.push(PATHS.BANKING)
  } else {
    checkLoadPage(to, from, next)
  }
})

router.afterEach(async (to, from) => {
  store.dispatch('currentRoute', to.path)
  if (from.fullPath === '/' && store.getters.lastUrl !== to.fullPath) {
    store.dispatch('cleanEditState')
  }
  if (to.path !== PATHS.HOME) {
    store.dispatch('cancelDashboardRequests')
  }
  if (!store.getters.isLoggedIn && to.meta.requiresAuth) {
    if (to.path === '/banking/tarefas') {
      store.dispatch('setLastUrl', to.fullPath)
      store.dispatch('setUpdateLocation', true)
    }
    await store.dispatch('logout')
    if (to.path !== PATHS.LOGIN) {
      router.push(PATHS.LOGIN)
    }
  } else {
    if (to && to.path !== PATHS.UNAUTHORIZED && to.meta && to.meta.requiresAuth) {
      const response = await store.dispatch('getFuncionalities')
      await store.dispatch('saveAllowedFuncionalities', response.data.allowedFunc)

      try {
        await store.dispatch('verifyTokenAndAuthorization', to.path)
        if (to.path === PATHS.LOGIN) {
          store.dispatch('setLastUrl', PATHS.HOME.path)
          router.push(PATHS.HOME)
        } else {
          store.dispatch('setLastUrl', to.fullPath)
        }
      } catch (e) {
        await store.dispatch('logout')
        if (to.path !== PATHS.LOGIN) {
          router.push(PATHS.LOGIN)
        }
      }
    }
  }
})

const checkLoadPage = (to, from, next) => {
  if (from.path === PATHS.MANUAL_CONCILIATION) {
    store.dispatch('alertUser').then(() => {
      next()
    }).catch()
  } else {
    next()
  }
}

export default router



// WEBPACK FOOTER //
// ./client/router/index.js